import React from 'react';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeConsultants } from '../components/home/HomeConsultants';
import { HomeHero } from '../components/home/HomeHero';
import { HomeIndustries } from '../components/home/HomeIndustries';
import { HomeInsights } from '../components/home/HomeInsights';
import { HomeIntro } from '../components/home/HomeIntro';
import { HomeProcess } from '../components/home/HomeProcess';
import { HomeServices } from '../components/home/HomeServices';
import { HomeWhy } from '../components/home/HomeWhy';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CtaBand } from '../components/ui/CtaBand';
import { consultants } from '../data/consultants';
import { services } from '../data/services';
import { usePageMeta } from '../hooks/usePageMeta';
import { SITE_NAME } from '../utils/seo';
export function Home() {
  usePageMeta(SITE_NAME, 'Aurevane Search Partners is an executive search firm connecting organizations with exceptional leaders for C-suite, board, and senior leadership appointments, including confidential searches.', {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: SITE_NAME,
    description: 'Executive search, C-suite recruitment, board and non-executive director search, and leadership talent advisory.',
    url: typeof window !== 'undefined' ? window.location.origin : undefined,
    serviceType: services.map(s => s.title),
    employee: consultants.map(c => ({
      '@type': 'Person',
      name: c.name,
      jobTitle: c.title,
      email: c.email
    }))
  });
  return <>
      <HomeHero data-id="element-825" data-mp="288ngpn69v695" />
      <HomeIntro data-id="element-826" data-mp="2861bvvarn4um" />
      <HomeServices data-id="element-827" data-mp="239167lhtw441" />
      <HomeIndustries data-id="element-828" data-mp="239j7wxn9fajc" />
      <HomeProcess data-id="element-829" data-mp="23ac81frpr1si" />
      <HomeWhy data-id="element-830" data-mp="23aue1446gudm" />
      <HomeConsultants data-id="element-831" data-mp="2376i5yb9fvvq" />
      <HomeAudiences data-id="element-832" data-mp="1z764wgzwdqq9" />
      <HomeInsights data-id="element-833" data-mp="1z6e852ukdmye" />
      <CtaBand title="The Right Leadership Can Change Everything." text="Whether you are building your leadership team or considering your next executive opportunity, begin a conversation with Aurevane Search Partners." data-id="element-834" data-mp="1z6wfauirlll3">
        <ButtonLink to="/contact" size="lg" data-id="element-835" data-mp="1om2fxtupjfqw">
          Contact Our Team
        </ButtonLink>
        <ButtonLink to="/consultants" variant="outline-light" size="lg" data-id="element-836" data-mp="1amj9r6lgieh8">
          Meet Our Consultants
        </ButtonLink>
      </CtaBand>
    </>;
}